import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { message } from 'antd';
import BrandAllListWrap from '../../views/brand/list/all/BrandAllListWrap';
import { appActions } from '../../store/modules/app';
import { brandActions } from '../../store/modules/brand';
import { BRAND_LIST_FILTER_OPTION_MODEL, BRAND_LIST_SORT_OPTION_MODEL } from '../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class BrandAllListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location } = this.props;

    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getInfo({
        filterOption: location.state.filterOption,
        sortOption: location.state.sortOption,
        pagination: location.state.pagination,
      });
    } else {
      /**
       *  페이지에 처음 접근하면 초기화된 검색 조건으로 검색한다.
       */
      this.getInfo({
        filterOption: BRAND_LIST_FILTER_OPTION_MODEL,
        sortOption: BRAND_LIST_SORT_OPTION_MODEL,
        pagination: LIST_PAGINATION_MODEL,
      });
    }
  };

  getInfo = (data) => {
    const { getBrandAllInfo, history } = this.props;
    const { filterOption, sortOption, pagination } = data;

    /**
     *  서버에 요청
     */
    getBrandAllInfo({
      filterOption,
      sortOption,
      pagination,
    });

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        filterOption,
        sortOption,
        pagination,
      },
    });
  };

  getList = (data) => {
    const { getBrandList, brandList, history } = this.props;
    const { filterOption, sortOption, pagination } = brandList;

    /**
     *  서버에 요청
     */
    getBrandList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getBrandExcelDownload, pageName, brandList, adminInfo } = this.props;

    if (!brandList || !brandList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getBrandExcelDownload({
      email: adminInfo.email,
      filterOption: brandList.filterOption,
      sortOption: brandList.sortOption,
      brandPageName: pageName,
    });
  };

  render() {
    const { brandList, currentTierList, openImgViewModal, getBrandTagColumnTagList } = this.props;

    return (
      <BrandAllListWrap
        brandList={brandList}
        currentTierList={currentTierList}
        openImgViewModal={openImgViewModal}
        getBrandTagColumnTagList={getBrandTagColumnTagList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    currentTierList: state.brand.currentTierList,
    brandList: state.brand.brandList,
  };
};

const mapDispatchToProps = {
  getBrandAllInfo: brandActions.getBrandAllInfo,
  getBrandList: brandActions.getBrandList,
  getBrandExcelDownload: brandActions.getBrandExcelDownload,
  getBrandTagColumnTagList: brandActions.getBrandTagColumnTagList,
  openImgViewModal: appActions.openImgViewModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandAllListContainer));
